<ui-card class="padding-4" [loading]="isLoading">
    <!-- Top of the component where we show the current month and year and the hours tracked -->
    <div class="flex margin-bottom-3">
        <div class="month-date-box flex col align-items-center justify-center">
            <div class="date">{{ dayOfMonth }}</div>
            <div class="month">{{ abbreviatedMonth }}</div>
        </div>
        <div class="hours-worked-box flex col">
            <div class="day-of-week">{{ dayOfTheWeek }}</div>
            <div class="today">{{ timeWorkedToday }}</div>
            <div *ngIf="isClockedIn" [@fadeInOut] class="active-timer">
                <mat-icon svgIcon="timeTrackingClock" class="small-icon"></mat-icon>
                <div class="timer-text">{{ activeTimer }}</div>

                @if (hourTypes.length > 0) {
                    <mat-divider [vertical]="true" class="timer-divider"></mat-divider>
                    <div class="timer-type">
                        {{ selectedHourType?.displayName ?? ('time-tracking.timeClockWidget.unpaid' | translate) }}
                    </div>
                }
            </div>
        </div>
    </div>

    <div class="grid">
        <mat-form-field class="no-labels no-helpers">
            <mat-select
                placeholder="{{ 'time-tracking.timeClockWidget.selectProject' | translate }}"
                [(ngModel)]="selectedProjectId"
            >
                <mat-option [value]="null">{{ 'time-tracking.timeClockWidget.none' | translate }}</mat-option>
                <mat-option *ngFor="let projectAssignment of projectAssignments" [value]="projectAssignment.project.id">
                    {{ projectAssignment.project.name }}
                </mat-option>
            </mat-select>
        </mat-form-field>

        @if (hourTypes.length > 0) {
            <ui-split-button
                class="margin-left-1"
                [type]="isClockedIn ? 'primary' : 'outline'"
                [splitButtonMenu]="splitMenu"
                [disabled]="isProcessing || isLoading"
                (click)="toggleTimeClockEntry()"
            >
                <mat-icon svgIcon="clockSingleHand" [class.rotating]="isClockedIn"></mat-icon>
                {{
                    isClockedIn
                        ? ('time-tracking.timeClockWidget.clockOutButton' | translate)
                        : ('time-tracking.timeClockWidget.clockInButton' | translate)
                }}
            </ui-split-button>

            <mat-menu #splitMenu="matMenu">
                @for (hourType of hourTypes; track hourType.id) {
                    <button mat-menu-item (click)="toggleTimeClockEntry(hourType)">
                        {{ hourType.displayName }}
                        @if (hourType.name === incomeTypes.Regular) {
                            ({{ 'time-tracking.timeClockWidget.default' | translate }})
                        }
                    </button>
                }
                <button mat-menu-item (click)="toggleTimeClockEntry(null)">
                    {{ 'time-tracking.timeClockWidget.unpaid' | translate }}
                </button>
            </mat-menu>
        } @else {
            <ui-button
                (click)="toggleTimeClockEntry()"
                class="margin-left-1"
                [type]="isClockedIn ? 'primary' : 'outline'"
                size="full-width"
                [disabled]="isProcessing || isLoading"
            >
                <mat-icon svgIcon="timeTrackingClock"></mat-icon>
                {{
                    isClockedIn
                        ? ('time-tracking.timeClockWidget.clockOutButton' | translate)
                        : ('time-tracking.timeClockWidget.clockInButton' | translate)
                }}
            </ui-button>
        }
    </div>
    <!-- Bottom of the component where we show the buttons -->
    <div class="buttons-box margin-top-3" #buttonsBox>
        <ui-button class="cta-button" url="/time-tracking/my-timesheet/create" type="link">
            <mat-icon svgIcon="plus"></mat-icon>
            {{ 'time-tracking.timeClockWidget.enterHoursButton' | translate }}
        </ui-button>
        <ui-button class="cta-button" url="/time-tracking/my-timesheet" type="link">
            {{ 'time-tracking.timeClockWidget.viewMyTimesheetButton' | translate }}
        </ui-button>
    </div>
</ui-card>
